import ResumeOne from "./ResumeOne";

export default ResumeOne;
